import { cloneElement } from 'react';
import { Pressable } from 'react-native';

import { Box, HStack, Text, theme } from '@squire/ui';

import { useScreenTranslations } from '@/hooks/useScreenTranslations';

import { styles } from './styles';
import type { PaymentBadgeIcon } from './types';

const PaymentMethodOption = ({
  id,
  selected,
  onPress,
  icon,
  label,
}: {
  selected: boolean;
  onPress: () => void;
  icon: PaymentBadgeIcon | null;
  label: string;
  id: string;
}) => {
  const { t } = useScreenTranslations('ConfirmBookingBottomSheet');

  styles.useVariants({ selected });

  return (
    <Pressable
      testID={id}
      onPress={onPress}
      accessibilityRole="radio"
      aria-checked={selected}
      style={[styles.paymentMethodOption]}
      accessibilityLabel={t('accessibility.paymentMethod', { method: label })}
      accessibilityHint={t('accessibility.paymentMethodHint', {
        method: label,
      })}
    >
      <HStack space={theme.spacing[3]} style={styles.paymentMethodRow}>
        {icon && (
          <Box style={styles.paymentMethodIcon}>
            {cloneElement(icon, { selected })}
          </Box>
        )}

        <Text
          variant="lStrong"
          color={selected ? 'textPrimaryInverse' : 'textPrimary'}
        >
          {label}
        </Text>
      </HStack>
    </Pressable>
  );
};

PaymentMethodOption.displayName = 'PaymentMethodOption';
export { PaymentMethodOption };
